import { render, staticRenderFns } from "./ExtraFieldBaseOptions.vue?vue&type=template&id=867d3f4a"
import script from "./ExtraFieldBaseOptions.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldBaseOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('867d3f4a')) {
      api.createRecord('867d3f4a', component.options)
    } else {
      api.reload('867d3f4a', component.options)
    }
    module.hot.accept("./ExtraFieldBaseOptions.vue?vue&type=template&id=867d3f4a", function () {
      api.rerender('867d3f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldBaseOptions.vue"
export default component.exports